/**
 * Instagram Archive — Learn-Mode inline tips.
 *
 * Covers the Stories surfaces of `routes/social/Archive.tsx` and
 * `routes/social/_sections/archive/PostsTab.tsx` + `StoriesGrid.tsx`
 * (Instagram Stories archived by the 6-hourly stories pass, 2026-10-03).
 */

import type { LearnTip } from "./types";

export const archiveTips: LearnTip[] = [
  {
    key: "archive-stories-stat",
    title: "Archived Stories",
    body: "How many Instagram Stories have been saved for the connected accounts. Stories are kept separate from feed posts, so they never inflate the post count next to them.",
  },
  {
    key: "archive-stories-filter",
    title: "Posts or Stories",
    body: "Switch between feed posts and Instagram Stories. Stories are captured every few hours while they are live, because Instagram removes them (and their numbers) 24 hours after posting.",
  },
  {
    key: "archive-stories-grid",
    title: "Story Results",
    body: 'Each card shows when the story went up and the last views, reach and link clicks Instagram reported while it was live. A number Instagram did not share reads "Not reported", never a zero. Story images come from Instagram and stop loading after a few days, so older cards show a placeholder.',
  },
];
